export default "__VITE_ASSET__D7Wa3TFa__"